import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { getTypeOfBirds, getTypeOfMammals, getTypeOfTags } from '../actions/tagActions';
import { TagTypeKey } from '../../types/tags';

export const tagAdapter = createEntityAdapter();
export type SubTagType = {
    id: string;
    key: string;
    name: string;
    type: string;
};
export type Tag = {
    id?: number;
};

export type TypeOfTag = {
    type: string;
};

export const InitialTag = {
    id: 0,
    name: '',
    description: '',
    type: 'hunting_tower' as TagTypeKey,
    sub_type: '',
    animal_type: '',
    images: [] as any[],
    latitude: '',
    longitude: '',
};

const INITIAL_STATE = {
    tagslist: [],
    isCreating: false,
    tagCreationStep: 1,
    newTag: InitialTag,
    // newTag: null,
    tagCoords: null,
    typeOfTags: [] as { type: TagTypeKey }[],
    typeOfBirds: [] as SubTagType[],
    typeOfMammals: [] as SubTagType[],
    isLoading: false,
    tagSheetVisible: false,
    tagData: null,
    newTagModalVisible: false,
    uploadTagProgress: 0,
};

const tagReducer = createSlice({
    name: 'tag',
    initialState: tagAdapter.getInitialState(INITIAL_STATE),
    reducers: {
        setCreatingStatusTagAction(state, action) {
            state.isCreating = action.payload;
        },
        setTagCreationStep(state, action) {
            state.tagCreationStep = action.payload;
        },
        setNewTagData(state, action) {
            state.newTag = action.payload;
        },
        setUploadTagProgress(state, action) {
            state.uploadTagProgress = action.payload;
        },
        setTagModalVisible(state, action) {
            state.newTagModalVisible = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTypeOfTags.fulfilled, (state, action) => {
                state.typeOfTags = action.payload;
            })
            .addCase(getTypeOfTags.rejected, () => {})
            .addCase(getTypeOfBirds.fulfilled, (state, action) => {
                state.typeOfBirds = action.payload;
            })
            .addCase(getTypeOfBirds.rejected, () => {})
            .addCase(getTypeOfMammals.fulfilled, (state, action) => {
                state.typeOfMammals = action.payload;
            })
            .addCase(getTypeOfMammals.rejected, () => {});
    },
});

export const {
    setUploadTagProgress,
    setTagModalVisible,
    setCreatingStatusTagAction,
    setTagCreationStep,
    setNewTagData,
} = tagReducer.actions;

export default tagReducer.reducer;
